import type { FC } from "react";
import { Toaster as HotToaster } from "react-hot-toast";
import { alpha } from "@mui/system/colorManipulator";
import { useTheme } from "@mui/material/styles";

export const Toaster: FC = () => {
  const theme = useTheme();

  return (
    <HotToaster
      containerStyle={{ margin: 0, padding: 0 }}
      position="bottom-right"
      toastOptions={{
        style: {
          background: alpha(theme.palette.neutral[900], 0),
          color: theme.palette.common.white,
          boxShadow: "none",
          padding: 0,
          margin: 0,
        },
      }}
    />
  );
};
